import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Checkbox', () => ({
		template: '<dms-check v-bind="$props" :value.sync="value" />',
		data() {
			return {
				value: null,
			};
		},
		props: {
			label: {
				default: text('Label', 'Souhlasím'),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
